import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router";
import useApi from "../customHooks/useAPI";

const MyConsultations = () => {
    const [consultations, setConsultations] = useState([]);
    const { doctorId } = useAuth();
    const navigate = useNavigate();
    const {callApi, loading} = useApi();

    const fetchConsultations = async () => {
        try {
            const response = await callApi({
                url: `${process.env.REACT_APP_BACKEND_ENDPOINT}/doctor/consultationSchedules`,
                headers: { "doctor-id": doctorId } 
            });
            console.log(response);
            
            setConsultations(response.data || []);
        } catch (error) {
            console.error("Error fetching consultations:", error);
        }
    };

    useEffect(() => {
        fetchConsultations();
    }, []);

    const groupedConsultations = consultations.reduce((acc, meeting) => {
        const date = new Date(meeting.start_time).toDateString(); // e.g., "Sat Oct 26 2025"
        if (!acc[date]) acc[date] = [];
        acc[date].push(meeting);
        return acc;
    }, {});

    const sortedDates = Object.keys(groupedConsultations).sort(
        (a, b) => new Date(a) - new Date(b)
    );

    const getDateHeading = (dateStr) => {
        const date = new Date(dateStr);
        const today = new Date();

        if (date.toDateString() === today.toDateString()) return "Today";

        const options = { weekday: "long", month: "short", day: "numeric", year: "numeric" };
        return date.toLocaleDateString(undefined, options);
    };

    return (
        <div className="pt-16 bg-gradient-to-br from-green-50 to-blue-50 min-h-screen p-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-8 text-center">
                My Consultations
            </h1>

            <div className="max-w-6xl mx-auto bg-white shadow-lg rounded-2xl p-6">
                {loading ? (
                    <p className="text-center text-gray-500">Loading consultations...</p>
                ) : consultations.length === 0 ? (
                    <p className="text-center text-gray-500">No consultations found.</p>
                ) : (
                    <div className="space-y-8">
                        {sortedDates.map((dateKey) => (
                            <div key={dateKey}>
                                <h2 className="text-xl font-semibold text-gray-700 mb-4 border-b pb-2">
                                    {getDateHeading(dateKey)}
                                </h2>

                                <div className="divide-y divide-gray-200">
                                    {groupedConsultations[dateKey].map((meeting) => (
                                        <div
                                            key={meeting.id}
                                            className="py-4 flex flex-col sm:flex-row sm:items-center justify-between hover:bg-gray-50 transition rounded-lg px-3"
                                        >
                                            <div>
                                                <h3 className="font-semibold text-gray-800">{meeting.title}</h3>
                                                <p className="text-sm text-gray-600">
                                                    {new Date(meeting.start_time).toLocaleTimeString([], {
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                    })}{" "}
                                                    to{" "}
                                                    {new Date(meeting.end_time).toLocaleTimeString([], {
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                    })}
                                                </p>
                                                <p className="text-sm text-gray-500 mt-1">{meeting.description}</p>
                                                {meeting.google_meet_link && (
                                                    <a
                                                        href={meeting.google_meet_link}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        className="text-blue-600 underline text-sm mt-1 inline-block"
                                                    >
                                                        Join Meet
                                                    </a>
                                                )}
                                            </div>

                                            <div className="mt-3 sm:mt-0 flex gap-3">
                                                <button
                                                    onClick={() => navigate(`/patient/${meeting.patient_id}`)}
                                                    className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg text-sm transition-all"
                                                >
                                                    See Patient
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default MyConsultations;
